<template>
  <div class="p-grid p-fluid p-justify-between">
    <div class="p-col search-row-data">
      <!--      {{ caption }}-->
      <span class="shorten-caption" :title="captionHint">{{ caption }}</span>
      <span class="shorten-caption-addition">&nbsp;{{ captionAddition }}</span>
    </div>
    <div class="p-col-1 row-button">
      <Button
        class="p-button-secondary"
        icon="pi pi-folder-open"
        v-on:click="openDialog"
        :disabled="disabled"
      ></Button>
    </div>
    <Dialog
      :style="{ width: '50vw', height: '50vw' }"
      :visible.sync="dialogVisible"
      class="my-dialog"
      modal
    >
      <template #header>
        {{ translate("dynamicTreeSelect.header") }}
      </template>
      <div class="p-grid">
        <div class="p-col-4">
          <div class="p-inputgroup">
            <InputText
              v-model="newProfileName"
              :placeholder="translate('placeholder.new.profilename')"
            />
            <Button
              :disabled="createProfileInActive"
              class="p-button-success"
              icon="pi pi-plus"
              v-on:click="addProfileClick"
            ></Button>
          </div>
          <DataTable
            :selection.sync="selectedProfile"
            :value="getProfiles"
            dataKey="id"
            selectionMode="single"
          >
            <Column field="profileName">
              <template #header>
                <div>{{ translate("profilename") }}</div>
              </template>
            </Column>
          </DataTable>
        </div>
        <div class="p-col-8">
          <Tree
            :filter="true"
            :loading="loading"
            :selectionKeys.sync="fieldValue"
            :value="options"
            filterMode="strict"
            selectionMode="checkbox"
          ></Tree>
        </div>
      </div>
      <template #footer>
        <div class="p-grid p-justify-between">
          <div class="p-col-3">
            <Button
              :disabled="selectedProfile === null"
              :label="translate('label.remove.profile')"
              class="p-button-danger"
              icon="pi pi-minus"
              style="text-align: left"
              v-on:click="removeProfileClick"
            ></Button>
          </div>
          <div class="p-col-9">
            <Button
              :disabled="selectedProfile === null"
              class="p-button-warning"
              icon="pi pi-save"
              label="Save Profile"
              v-on:click="saveProfileClick"
            />
            <Button
              :label="translate('button.cancel')"
              class="p-button-secondary"
              icon="pi pi-times"
              v-on:click="cancelClick"
            />
            <Button
              :label="translate('button.apply')"
              icon="pi pi-check"
              v-on:click="applyClick"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchFieldService from "../services/searchfield.service";
import TranslateService from "../services/translate.service";
import _ from "lodash";

export default {
  name: "DynamicTreeSelect",
  props: {
    uniqueId: Number,
    fieldName: String,
    disabled: Boolean
  },
  data() {
    return {
      options: [],
      loading: false,
      newProfileName: "",
      selectedProfile: null,
      dialogVisible: false,
      fieldValue: null,
      shortText: { shortText: "", descriptionText: "" }
    };
  },
  methods: {
    ...mapActions("search", ["setData"]),
    ...mapActions("wizard", ["addProfile", "activateTable", "removeProfile"]),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    applyClick() {
      let search = this.objectToSearchString(this.fieldValue);
      this.loadShortText(search);
      let list = [];
      for (let key in this.fieldValue) {
        list.push(key);
      }
      this.setData({ uniqueId: this.uniqueId, data: list });
      this.dialogVisible = false;
    },
    cancelClick() {
      this.dialogVisible = false;
    },
    loadShortText(search) {
      if (this.fieldName === "TYPE_OF_RIGHTS") {
        SearchFieldService.loadRightsDisplayText(search).then(r => {
          this.shortText = r.data;
        });
      } else {
        SearchFieldService.loadTerritoryDisplayText(search).then(r => {
          this.shortText = r.data;
        });
      }
    },
    objectToSearchString(list) {
      let search = "[";
      for (let r in list) {
        if (search !== "[") {
          search = search + ", ";
        }
        search = search + '"' + r + '"';
      }
      search = search + "]";
      return search;
    },
    openDialog() {
      this.loading = true;
      this.selectedProfile = null;
      SearchFieldService.loadLookupData(this.fieldName).then(r => {
        this.options = r.data;

        this.loading = false;
      });

      this.activateTable(this.fieldName);
      this.dialogVisible = true;
    },

    load() {
      let val = this.getData(this.uniqueId);
      let obj = {};
      for (let v of val) {
        if (v !== "") {
          obj[v] = {};
        }
      }
      console.log("This model gehts in tree", obj);

      // const input = Object.keys(obj);
      this.fieldValue = obj;
      let search = this.objectToSearchString(obj);

      this.loadShortText(search);
    },
    addProfileClick() {
      let search = { ...this.fieldValue };
      let profile = {
        profileName: this.newProfileName,
        fieldName: this.fieldName,
        profileContent: search
      };
      this.newProfileName = "";
      this.addProfile(profile).then(r => {
        this.selectedProfile = r;
      });
    },
    saveProfileClick() {
      let search = { ...this.fieldValue };
      let profile = _.cloneDeep(this.selectedProfile);
      _.set(profile, "profileContent", search);
      this.newProfileName = "";
      this.addProfile(profile).then(r => {
        this.selectedProfile = r;
      });
    },
    loadProfile() {
      if (this.selectedProfile != null) {
        this.newProfileName = "";
        console.log(
          "and this gehts from the profile",
          this.selectedProfile.profileContent
        );
        this.fieldValue = { ...this.selectedProfile.profileContent };
      }
    },
    clearSelection() {
      if (this.newProfileName !== "") {
        this.selectedProfile = null;
      }
    },
    removeProfileClick() {
      this.removeProfile(this.selectedProfile).then(() => {
        this.selectedProfile = null;
      });
    },

    isNodeFullyChecked(node, selectedKeyArray) {
      if (node.children && node.children.length > 0) {
        return node.children.every(childNode => {
          return this.isNodeFullyChecked(childNode, selectedKeyArray);
        });
      } else {
        return selectedKeyArray.includes(node.key);
      }
    },

    getCheckedNodes(node, selectedKeyArray, result = []) {
      if (selectedKeyArray.includes(node.key)) {
        result.push(node);
      }
      if (node.children && node.children.length > 0) {
        for (let child of node.children) {
          result = this.getCheckedNodes(child, selectedKeyArray, result);
        }
      }
      return result;
    },

    /**
     * Returns an object in the structure {key:{checked:bool,partialChecked:bool}}
     * @param selectedKeys must be an array of GUIDS
     * @param treeObjectList must be an array of nested tree objects
     * @returns {Object}
     */
    buildTreeSelection(selectedKeys, treeObjectList) {
      let res = {};
      // We have the selectedKeysArray, but we don't know if its nodes are fully checked (e.g. if the tree changes)
      if (selectedKeys && treeObjectList && treeObjectList[0]) {
        // first we get all checked nodes (full OR partial) from all trees in the array
        let checkedNodes = [];
        for (const tree of treeObjectList) {
          checkedNodes = checkedNodes.concat(
            this.getCheckedNodes(tree, selectedKeys)
          );
        }
        // then we check if the nodes are fully checked and construct the result object
        for (let node of checkedNodes) {
          res[node.key] = this.isNodeFullyChecked(node, selectedKeys)
            ? { checked: true, partialChecked: false }
            : { checked: false, partialChecked: true };
        }
      }
      // return the object {'blablaKey':{checked:true, partialChecked:false}
      return res;
    }
  },
  watch: {
    newProfileName() {
      this.clearSelection();
    },
    selectedProfile() {
      this.loadProfile();
    },
    options(nv) {
      const input = Object.keys(this.fieldValue);
      this.fieldValue = this.buildTreeSelection(input, nv);
    }
  },
  computed: {
    // computedFieldValue() {
    //   if (this.fieldValue) {
    //     const input = Object.keys(this.fieldValue);
    //     return this.buildTreeSelection(input, this.options);
    //   }
    //   return this.fieldValue;
    // },
    ...mapGetters("search", ["getData"]),
    ...mapGetters("wizard", ["getProfiles"]),
    caption() {
      return this.shortText.shortText;
    },
    captionAddition() {
      if (this.shortText.additionCount) {
        return " (+" + this.shortText.additionCount + " more)";
      }
      return null;
    },
    captionHint() {
      return this.shortText.descriptionText;
    },
    createProfileInActive() {
      return this.newProfileName.trim() === "";
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped>
.row-button {
  text-align: right;
  margin-right: 15px;
}

.my-dialog .p-dialog .p-dialog-footer {
  text-align: left;
}
</style>
